<template>
  <div class="box">
    <div class="content">
      <div class="item" v-for="item in list" :key="item" @click="handleClick(item)">
        {{ item }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: ['2022', '2023', '2024'],
    }
  },
  methods: {
    handleClick(item) {
      this.$store.commit('SET_YEAR', item)
      this.$emit('change')
    },
  },
}
</script>
<style lang="less" scoped>
.box {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 1000000;
  background: #fff;

  display: flex;
  align-items: center;
  justify-content: center;
  .content {
    width: 1200px;
    display: flex;
    justify-content: space-between;

    .item {
      width: 250px;
      height: 250px;
      border-radius: 50%;
      background-color: #cccccc;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 40px;
      font-weight: bold;
      cursor: pointer;
      &:hover {
        background-color: #409eff;
      }
    }
  }
}
</style>
